var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 20.5C41 31.8218 31.8218 41 20.5 41C9.17816 41 0 31.8218 0 20.5C0 9.17816 9.17816 0 20.5 0C31.8218 0 41 9.17816 41 20.5Z",
    fill: "#4AB7D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.059 27.9408H29.0035C29.5905 27.9408 30.0664 28.4167 30.0664 29.0037C30.0664 29.5908 29.5905 30.0667 29.0035 30.0667H11.9961C11.409 30.0667 10.9331 29.5908 10.9331 29.0037V11.9963C10.9331 11.4093 11.409 10.9333 11.9961 10.9333C12.5831 10.9333 13.059 11.4093 13.059 11.9963V27.9408Z",
    fill: "#4AB7D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.0235 23.353C16.622 23.7812 15.9493 23.8029 15.521 23.4014C15.0927 22.9999 15.071 22.3272 15.4726 21.8989L19.4587 17.6471C19.847 17.2329 20.4922 17.197 20.9241 17.5655L24.0702 20.2502L28.1693 15.058C28.533 14.5973 29.2015 14.5186 29.6622 14.8824C30.123 15.2462 30.2016 15.9146 29.8379 16.3754L25.0545 22.4342C24.6809 22.9075 23.9889 22.9756 23.5303 22.5842L20.3158 19.8412L17.0235 23.353Z",
    fill: "#4AB7D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/GraphIcon.00a248ef66cd4275cacbddfe477a8751.svg";
export { ForwardRef as ReactComponent };